<div class="all-reports">
  <div class="title">{{ 'dashboard:Select Report' | i18next }}</div>
  <div class="filter-wraper">
    <div [ngClass]="['filter-icon', 'search-icon']"><i class="fal fa-search"></i></div>
    <input type="text" [(ngModel)]="filter" class="filter" placeholder="{{ 'Search' | i18next }}" />
    <div [ngClass]="['filter-icon', 'clear-icon']"><button *ngIf="filter.length>0" (click)="filter=''"><i class="fal fa-times"></i></button>
    </div>
  </div>
  <div *ngIf="!isStandAlone" class="reports-list thin-scroll">
    <div class="report" *ngFor="let report of filteredReports()" (click)="onReportSelected(report)"
      [class.selected]="gridItem.setup.reportId==report.id && gridItem.setup.reportSubId==report.subReportId">
      <span>{{report.shortDescription}} </span>
      <button (click)="showHelp($event,report)" class="help-icon"><i class="fal fa-question-circle"></i> </button>
    </div>
    <div *ngIf="filteredReports()?.length==0 " class="list-box-empty">
      <i class="fal fa-search"></i>
      <span>{{"dashboard:Sorry, we couldn't find any results." | i18next}}</span>
    </div>
  </div>
  <div *ngIf="isStandAlone" class="reports-list thin-scroll">
    <div class="report-list-type">{{"dashboard:Standard Reports" | i18next}}</div>
    <div class="report" *ngFor="let report of filteredReports('standard')" (click)="onReportSelected(report)"
      [class.selected]="gridItem.setup.reportId==report.id && gridItem.setup.reportSubId==report.subReportId">
      <span>{{report.shortDescription}} </span>
      <button (click)="showHelp($event,report)" class="help-icon"><i class="fal fa-question-circle"></i> </button>
    </div>
    <div *ngIf="filteredReports('standard')?.length==0 ">
      <span>{{"dashboard:Sorry, we couldn't find any results." | i18next}}</span>
    </div>
    <div class="report-list-type">{{"dashboard:Custom Reports" | i18next}}</div>
    <div class="report" *ngFor="let report of filteredReports('custom')" (click)="onReportSelected(report)"
      [class.selected]="gridItem.setup.reportId == report.id && gridItem.setup.reportSubId == report.subReportId">
      <span>{{report.shortDescription}} </span>
      <button (click)="showHelp($event,report)" class="help-icon"><i class="fal fa-question-circle"></i> </button>
    </div>
    <div *ngIf="filteredReports('custom')?.length == 0 " >
      <span>{{"dashboard:Sorry, we couldn't find any results." | i18next}}</span>
    </div>
  </div>


</div>
<div class="report-details">
  <app-reports-settings *ngIf="loadedReport" [gridItem]="gridItem" [report]="loadedReport" [isStandAlone]="isStandAlone"
    [notifier]="notifier" (viewReport)="viewReport()"
    (completedNotifier)="completedNotifier($event)" (refreshNotifier)="refreshNotifier($event)"></app-reports-settings>
  <app-repQDetails *ngIf="showReport && isStandAlone" [gridItem]="gridItem" [dataEquality]="dataEquality"
    [isStandAlone]="isStandAlone"></app-repQDetails>
  <div *ngIf="this.gridItem.setup.reportId == null" class="list-box-empty">
    <i class="fal fa-cogs"></i>
    <span>{{"dashboard:Select from the list of reports to show configuration" | i18next}}</span>
  </div>
</div>
